import { AnswerType } from '../../shared/enums/answer.enum';

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export abstract class Answer {
  public id!: string;

  public type!: AnswerType;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public abstract answer: any;

  protected static mapBaseProperties(answer: Answer, dto: any): void {
    answer.id = dto.id;
    answer.type = dto.type;
  }

  /**
   * Method to check if the given answer is acceptable.
   *
   * Conditional statement and boolean conversion (example: `if (thisOne)`) can be
   * dangerous when checking if an answer is filled or not. The `0` for example
   * returns false in a conditional statement with boolean conversion.
   *
   * The method states in the following example are valid:
   *   0, -0, false, []
   * And these are invalid:
   *   NaN, undefined, null, ""
   */
  public isAcceptableAnswer(): boolean {
    if (
      this.answer === undefined ||
      (Array.isArray(this.answer) && this.answer.length === 0) ||
      this.answer === ''
    ) {
      return false;
    }
    if (typeof this.answer === 'number' && isNaN(this.answer)) {
      return false;
    }

    return this.answer !== null;
  }
}
